"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "garbagnate-milanese": {
    "77726a0a": [{
      "hkey": "7e20aa0f",
      "slug": "garbagnate-milanese",
      "name": "Garbagnate Milanese",
      "primary": true,
      "skipSearch": false
    }],
    "barianella": [{
      "hkey": "7e20aa0f",
      "slug": "garbagnate-milanese",
      "name": "Garbagnate Milanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db0447bb": [{
      "hkey": "4aae000c",
      "slug": "santa-maria-rossa-quadrifoglio-serenella",
      "name": "Santa Maria Rossa-Quadrifoglio-Serenella",
      "primary": true,
      "skipSearch": false
    }],
    "quadrifoglio": [{
      "hkey": "4aae000c",
      "slug": "santa-maria-rossa-quadrifoglio-serenella",
      "name": "Santa Maria Rossa-Quadrifoglio-Serenella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "garbagnate-milanese"
    }],
    "b1cfbd93": [{
      "hkey": "4aae000c",
      "slug": "santa-maria-rossa-quadrifoglio-serenella",
      "name": "Santa Maria Rossa-Quadrifoglio-Serenella",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-rossa": [{
      "hkey": "4aae000c",
      "slug": "santa-maria-rossa-quadrifoglio-serenella",
      "name": "Santa Maria Rossa-Quadrifoglio-Serenella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7c81737a": [{
      "hkey": "4aae000c",
      "slug": "santa-maria-rossa-quadrifoglio-serenella",
      "name": "Santa Maria Rossa-Quadrifoglio-Serenella",
      "primary": true,
      "skipSearch": false
    }],
    "serenella": [{
      "hkey": "4aae000c",
      "slug": "santa-maria-rossa-quadrifoglio-serenella",
      "name": "Santa Maria Rossa-Quadrifoglio-Serenella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "garbagnate-milanese"
    }],
    "d5ea2935": [{
      "hkey": "7e20aa0f",
      "slug": "garbagnate-milanese",
      "name": "Garbagnate Milanese",
      "primary": true,
      "skipSearch": false
    }],
    "siolo": [{
      "hkey": "7e20aa0f",
      "slug": "garbagnate-milanese",
      "name": "Garbagnate Milanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;